import { createSelector } from 'reselect';
import { getUpdatedItems } from 'store/items/selectors';
import { getSuggestedItemsOptions } from '../suggested-items/selectors';
import { FILTER_KEYS } from './fixtures';
import { getImages } from '../browse-items/selectors';

export const getWishlistItemsInitial = ({ wishlistItems }) => wishlistItems.data;
export const getWishlistItems = createSelector(
  getWishlistItemsInitial,
  getUpdatedItems,
  (items, updatedItems) => items.map((item) => {
    return {
      ...item,
      // wishlist item has 'deleted' like behavior when item.is_wishlisted becomes false or item is deleted at all
      isDeleted: updatedItems?.[item.id]?.isDeleted || (updatedItems?.[item.id] && typeof updatedItems?.[item.id]?.is_wishlisted !== 'undefined'),
      images: getImages(item?.images),
    };
  }),
);

export const getUpdatedWishlistItems = ({ id, data }) => createSelector(
  getWishlistItems,
  (items) => items.reduce((result, item) => {
    if(item.id !== id) {
      return [...result, {
        ...item,
        images: getImages(item?.images),
      }];
    }

    return [
      ...result,
      {
        ...data,
        item_name: data.name,
      },
    ];
  }, []),
);
export const getWishlistItemsLoadingState = ({ wishlistItems }) => wishlistItems.loading;
export const getWishlistItemsFilters = ({ wishlistItems }) => wishlistItems.filters;
// eslint-disable-next-line max-len
export const getSelectedWishlistItemsIds = ({ wishlistItemsActions }) => wishlistItemsActions.selectedIds;
// eslint-disable-next-line max-len
export const getOpenedWishlistItem = ({ wishlistItemsActions }) => wishlistItemsActions.openedItemId;

export const getSelectedItems = createSelector(
  getWishlistItems,
  getSelectedWishlistItemsIds,
  (items, ids) => items
    .filter(({ id }) => ids.includes(id)),
);

export const getSelectedItemTypeNames = createSelector(
  getWishlistItems,
  getSelectedWishlistItemsIds,
  (items, ids) => items
    .filter(({ id }) => ids.includes(id))
    .map(({ title }) => title),
);

export const getQueryArray = createSelector(
  getWishlistItemsFilters,
  ({
    [FILTER_KEYS.PAGE]: page,
    [FILTER_KEYS.PER_PAGE]: perPage,
    // [FILTER_KEYS.TYPE]: itemTtpe,
    [FILTER_KEYS.HAS_MORE]: hasMore,
    [FILTER_KEYS.SORT_DIRECTION]: sortDirection,
    ...queryParams
    // eslint-disable-next-line no-shadow,max-len
  }) => Object.keys(queryParams).reduce((result, type) => {
    switch (type) {
    case FILTER_KEYS.QUERY: {
      const query = queryParams[type];

      if(query) {
        return [
          ...result,
          ...queryParams[type].split(',').map((entity) => ({ type, value: entity, text: entity })),
        ];
      }

      return result;
    }
    case FILTER_KEYS.TAGS:
    case FILTER_KEYS.ITEMS: {
      const isEmpty = queryParams[type].length === 0;
      if (!isEmpty) {
        return [
          ...result,
          ...queryParams[type].map((entity) => ({ type, value: entity.id, text: entity.name })),
        ];
      }

      return result;
    }

    default: {
      return result;
    }
    }
  }, []),
);

export const getWishlistSuggestedItemsOptions = createSelector(
  getQueryArray,
  getSuggestedItemsOptions,
  (selectedQueryItems = [], suggestedQueryItems = []) => {
    const existingIds = selectedQueryItems.map(({ value }) => value);

    return suggestedQueryItems.filter((item) => !existingIds.includes(item.value));
  },
);
